const DYNAMIC_WORK_ORDER_PRODUCTS = [
  'MP-B32SRNPRQ2JGX2CKWX2KNN2Q8PBMQ7LC', // T41P Demo test product
  'MP-QHW8S8F6CKRB8VF7FHVXQ8PWXL55TNC6', // T41P Prod test product
  'MP-B7PHXSW5JMK7R2DRC6TVJFR2X3V52NWL', // Self-service MatchCraft Ads (dev)
  'MP-WVXC6XCWLKWSF56SBD7CFL8HJ3ZJVFP3', // Self-service MatchCraft Ads (test)
  'MP-2W3LXN5GMHMZ5QLZSKNW8QDSZTJWKG2Z', //(Search Beta) Digital Ads: Campaign
  'MP-8MS2CFPW6TM2WW4RZK3D4JZGKM6LF6MZ', // MatchCraft Awareness Digital Ads Campaign
];

export function productUsesDynamicWorkOrder(productId: string): boolean {
  return DYNAMIC_WORK_ORDER_PRODUCTS.includes(productId);
}
